var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-4" }, [
    _vm._m(0),
    _c("div", { staticClass: "row chart-container" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("v-chart", { staticClass: "chart", attrs: { option: _vm.option } })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "text-center h3" }, [
          _vm._v(" Suppliers Performance ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }